// store/slices/orderSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { constants } from '../../constants';

const orderSlice = createSlice({
  name: 'order',
  initialState: {
    order_details: [],
    customername: '',
    customeremail: '',
    customerphonenumber: '',
    discountamount:0,
    paymentmode:constants.PAYMENT_MODE.CASH,
    paymentstatus:constants.PAYMENT_STATUS.PENDING,
  },
  reducers: {
    addProductToOrder: (state, action) => {
      const product = action.payload;
    
      const exists = state.order_details.some(item => item.id === product.id);
    
      if (!exists) {
        state.order_details.push({
          ...product,
          orderQty: 1,
          unitprice: product.price, 
        });
      }
    },
    updateProductInOrder: (state, action) => {
      const { id, field, value } = action.payload;
      const product = state.order_details.find(p => p.id === id);
      if (!product) return;

      product[field] = value;

    },
    removeOrderItem: (state, action) => {
      state.order_details = state.order_details.filter(p => p.id !== action.payload);
    },
  
    updateOrderdata: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    resetOrder: () => ({
      order_details: [],
      customername: '',
      customeremail: '',
      customerphonenumber: '',
    discountamount:0,
    paymentmode:constants.PAYMENT_MODE.CASH,
    paymentstatus:constants.PAYMENT_STATUS.PENDING
    }),
  },
});

export const {
  addProductToOrder,
  updateProductInOrder,
  removeOrderItem,
  resetOrder,
  updateOrderdata
} = orderSlice.actions;

export default orderSlice.reducer;
